import useApi from '../../useApi'

const useSubManagementReq = () => {
  const Request = useApi()
  const subscriptionDetails = async (productId, tenantId) => {
    return await Request.get(
      `management/sadmin/v1/products/${productId}/Tenants/${tenantId}`
    )
  }
  const subscriptionFilteredList = async (query) => {
    return await Request.get(`management/sadmin/v1/Subscriptions${query}`)
  }
  const subscriptionCanceledFilteredList = async (query) => {
    return await Request.get(
      `management/sadmin/v1/Subscriptions/canceled${query}`
    )
  }
  const subscriptionFeturesList = async (subscriptionId) => {
    return await Request.get(
      `management/sadmin/v1/Subscriptions/${subscriptionId}/Features`
    )
  }
  const subscriptionCycleById = async (subscriptionId, cycleId) => {
    return await Request.get(
      `management/sadmin/v1/Subscriptions/${subscriptionId}/Cycles/${cycleId}`
    )
  }

  const subscriptionDetailsRenew = async (productId, tenantId, data) => {
    return await Request.post(
      `management/sadmin/v1/products/${productId}/Tenants/${tenantId}/Renew`,
      data
    )
  }
  const subscriptionDetailsResetSub = async (data) => {
    return await Request.post(`management/sadmin/v1/Subscriptions/Reset`, data)
  }

  const subscriptionDetailsLimitReset = async (data) => {
    return await Request.post(
      `management/sadmin/v1/Subscriptions/Features/Reset`,
      data
    )
  }
  const getAutoRenewalList = async () => {
    return await Request.get(`management/sadmin/v1/Subscriptions/Renewals`)
  }
  const setAutoRenewal = async (data) => {
    return await Request.post(
      `management/sadmin/v1/Subscriptions/AutoRenewal`,
      data
    )
  }
  const cancelAutoRenewal = async (data) => {
    return await Request.delete(
      `management/sadmin/v1/Subscriptions/AutoRenewal`,
      { data }
    )
  }
  const upgradeSubscription = async (data) => {
    return await Request.post(
      `management/sadmin/v1/Subscriptions/Upgrade`,
      data
    )
  }
  const downgradeSubscription = async (data) => {
    return await Request.post(
      `management/sadmin/v1/Subscriptions/Downgrade`,
      data
    )
  }
  const cancelSubscriptionRequest = async (data) => {
    return await Request.post(`management/sadmin/v1/Subscriptions/Cancel`, data)
  }
  const suspendSubscriptionRequest = async (data) => {
    return await Request.post(
      `management/sadmin/v1/Subscriptions/Suspend`,
      data
    )
  }
  const activateSubscriptionRequest = async (data) => {
    return await Request.post(
      `management/sadmin/v1/Subscriptions/Activate`,
      data
    )
  }
  const getSubscriptionsList = async () => {
    return await Request.get(`management/sadmin/v1/Subscriptions/All`)
  }
  const SubscriptionCancelationSubmit = async (data) => {
    return await Request.post(`public/v1/Subscriptions/Cancel`, data)
  }
  const subscriptionCancelationLink = async (data) => {
    return await Request.post(
      `management/sadmin/v1/Subscriptions/CancelationLink`,
      data
    )
  }
  const subscriptionPaymentLink = async (id, data) => {
    return await Request.post(
      `management/sadmin/v1/Subscriptions/${id}/PaymentLink`,
      data
    )
  }
  const subscriptionCancelationLinkWithEmail = async (data) => {
    return await Request.post(
      `management/sadmin/v1/Subscriptions/CancelationLink/WithEmail`,
      data
    )
  }

  return {
    subscriptionDetails,
    subscriptionDetailsRenew,
    subscriptionDetailsResetSub,
    subscriptionDetailsLimitReset,
    setAutoRenewal,
    cancelAutoRenewal,
    upgradeSubscription,
    downgradeSubscription,
    subscriptionFeturesList,
    subscriptionCycleById,
    getSubscriptionsList,
    getAutoRenewalList,
    cancelSubscriptionRequest,
    suspendSubscriptionRequest,
    activateSubscriptionRequest,
    subscriptionFilteredList,
    subscriptionCanceledFilteredList,
    SubscriptionCancelationSubmit,
    subscriptionCancelationLink,
    subscriptionCancelationLinkWithEmail,
    subscriptionPaymentLink,
  }
}
export default useSubManagementReq
